<template>
  <div class="TestKitSee">

    <div class="TestKitSee-main">

      <mu-form ref="form" :model="form">
        <mu-form-item label="受检人手机号" prop="phoneNo" :rules="rules.phoneNoRules"
                      :error-text="verify_error"
                      label-float
                      icon="phone_iphone">
          <mu-text-field v-model="form.phoneNo" @keyup.enter.native=onSubmit(form) ></mu-text-field>
        </mu-form-item>
        <mu-form-item label="短信验证码" prop="verifyCode" :rules="rules.verifyCodeRules" label-float icon="verified_user">
          <mu-text-field v-model="form.verifyCode" @keyup.enter.native=onSubmit(form) >
            <template #append>
              <mu-button v-if="!is_verify"
                         color="primary"
                         small
                         round
                         @click="get_verify(form.phoneNo)">获取验证码</mu-button>
              <van-count-down
                v-show="is_verify"
                ref="countDown"
                :time="60000"
                :auto-start="false"
                format="ss"
                @finish="finish"
              />
            </template>
          </mu-text-field>
        </mu-form-item>
        <mu-form-item>
          <mu-button @click="onSubmit(form)" style="width: 100%; height: 52px;" round color="primary">确定</mu-button>
        </mu-form-item>
      </mu-form>

      <div class="TestKitSee-main-tips">
        请务必使用与受检人筛查问卷中登记一致的手机号码
      </div>

    </div>

  </div>
</template>

<script>
import {CountDown} from "vant"

export default {
  name: "TestKitSee",
  data() {
    return {
      form: {
        phoneNo: null,
        verifyCode: null,
        sort: this.$route.query.state
      },
      rules: {
        phoneNoRules: [
          { validate: (val) => !!val, message: '请输入受检人手机号'},
          { validate: (val) => /^((13[0-9])|(14[0,1,4-9])|(15[0-3,5-9])|(16[2,5,6,7])|(17[0-8])|(18[0-9])|(19[0-3,5-9]))\d{8}$/.test(val), message: '受检人手机号不正确'},
        ],
        verifyCodeRules: [
          { validate: (val) => !!val, message: '请输入验证码'},
          { validate: (val) => val.length == 6, message: "验证码长度应为 6 位"}
        ]
      },
      is_verify: false,
      verify_error: null,
    }
  },
  created() {
    if(this.$route.query.code) {
      this.sentCode(this.$route.query.code);
    }
  },
  mounted() {

  },
  methods: {
    // 微信授权code
    sentCode(e) {
      this.$get("wx/userAuth",{code : e})
          .then(res => {
            console.log(res);
          })
    },
    onSubmit(formName) {
      this.$refs.form.validate()
        .then((res) => {
          if(res) {

           console.log(formName);

           this.$get("reagent/result",formName)
              .then(res => {
                console.log(res);

                if(res) {
                  this.$router.push({
                    path: "/TestKitSeeResult",
                    query: {
                      result: res.data.result,
                      reagentId: res.data.reagentId,
                    }
                  })
                }else {
                  this.$toast.fail(res.data.message);
                }

              })



          }
        })
    },
    get_verify(e) {
      if(/^((13[0-9])|(14[0,1,4-9])|(15[0-3,5-9])|(16[2,5,6,7])|(17[0-8])|(18[0-9])|(19[0-3,5-9]))\d{8}$/.test(e)) {
        let obj= {}
        obj["phoneNo"]= e;


        this.$get("reagent/send/verifyCode",obj)
          .then(res => {

            console.log(res);
            if(res) {
              this.is_verify= true;
              this.$refs.countDown.start();
            }else {
              this.$toast.fail(res.data.message);
            }

          })


      }else {
        this.verify_error= "请输入正确手机号"
      }
    },
    finish() {
      this.is_verify= false;
      this.$refs.countDown.reset();
    },
  },
  components: {
    [CountDown.name]: CountDown,
  }
}
</script>

<style lang="scss" scoped>
 @import "../../style/TestKit/TestKitSee";
</style>
